import { CarouselProvider, Slider, Slide, DotGroup } from "pure-react-carousel"
import useWindowSize from "utilities/useWindowSize"
import "pure-react-carousel/dist/react-carousel.es.css"
import Card from "components/SmallArticleCard"

export default function ThreeCardSection({ category, cards }) {
  const windowWidth = useWindowSize().width

  return (
    <section className="bg-gray-gradient">
      <div className="max-w-screen-xl mx-auto px-5 py-10 lg:py-16">
        <h2 className="text-center pb-8">{category}</h2>
        <CarouselProvider
          naturalSlideWidth="10px"
          naturalSlideHeight="100px"
          totalSlides={cards.length}
          visibleSlides={windowWidth <= 1180 ? 1 : 3}
          touchEnabled
          isIntrinsicHeight
        >
          <Slider>
            {cards.map((card, idx) => (
              <Slide key={idx}>
                <div className="mx-4">
                  <Card
                    video={{ component: "yt_embed", id: card.content.video_id }}
                    image={card.content.image}
                    link={card.content.link}
                    cta_text={card.content.cta_text}
                    title={card.content.title}
                    description={card.content.description}
                  />
                </div>
              </Slide>
            ))}
          </Slider>
          <DotGroup className="three-card-slider mt-6" />
        </CarouselProvider>
      </div>
    </section>
  )
}
